import { Box, Container } from "@mui/material"

import DrawerNav from "./nav.js"

function MainLayout({ children, backToDashboard=false, activeComponent='/' }) {

  return (
    <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      minHeight: '100%',
    }}
    >
      <DrawerNav backToDashboard={backToDashboard} activeComponent={activeComponent} />
      <Box sx={{ display: 'flex', flex: '1 1 auto', flexDirection: 'column', pl: { lg: '280px' }, paddingTop: '32px'}}>
        <main>
          <Container maxWidth="xl" sx={{ py: '64px' }}>
            {children}
          </Container>
        </main>
      </Box>
    </Box>
  )
}

export default MainLayout